import { defineStore } from 'pinia'
import { axiosInstance } from 'boot/axios'

export const useMenusStore = defineStore('menus', {
  state: () => ({
    items: [],
    selected: {
      name: '',
      url: '',
      id: null
    }
  }),
  actions: {
    fetch() {
      return axiosInstance
        .get('public/menus')
        .then(({ data }) => {
          this.items = data.menus
        })
        .catch(() => {
          this.items = []
        })
    },
    setSelected(menu) {
      if (typeof menu !== 'undefined') {
        this.selected = menu
      }
    },
    setItems(items) {
      this.items = items
    }
  }
})
